// extracted by mini-css-extract-plugin
export var divider = "_redotech-redo-web-lib-arbiter-components-divider-divider-divider";
export var dividerText = "_redotech-redo-web-lib-arbiter-components-divider-divider-divider-text";
export var dividerVertical = "_redotech-redo-web-lib-arbiter-components-divider-divider-divider-vertical";